import { render } from "./ProcessesHome.vue?vue&type=template&id=6a162735&scoped=true&ts=true&lang=pug"
import script from "./ProcessesHome.vue?vue&type=script&lang=ts"
export * from "./ProcessesHome.vue?vue&type=script&lang=ts"

import "./ProcessesHome.vue?vue&type=style&index=0&id=6a162735&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a162735"]])

export default __exports__